import { defineComponent as _defineComponent } from 'vue'
import { TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../adapter-vue";
import Icon from "../../common/Icon.vue";
import searchIcon from "../../../assets/icon/search.svg";
import closeIcon from "../../../assets/icon/input-close.svg";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  placeholder: {
    type: String,
    default: () => TUITranslateService.t("TUISearch.搜索"),
  },
  searchType: {
    type: String,
    default: "global", // "global":全局搜索, "conversation":会话内搜索
    validator(value: string) {
      return ["global", "conversation"].includes(value);
    },
  },
},
  setup(__props) {

const props = __props



const searchValueModel = ref<string>("");
const currentSearchInputValue = ref<string>("");
const searchingStatus = ref<boolean>(false);

TUIStore.watch(StoreName.CUSTOM, {
  currentSearchInputValue: (obj: { value: string; searchType: string }) => {
    if (obj?.searchType === props?.searchType) {
      currentSearchInputValue.value = obj?.value;
      searchValueModel.value = obj?.value;
    }
  },
  currentSearchingStatus: (obj: { isSearching: boolean; searchType: string }) => {
    if (obj?.searchType === props?.searchType) {
      searchingStatus.value = obj?.isSearching;
    }
  },
});

const search = () => {
  // 避免重复搜索
  if (searchValueModel.value === currentSearchInputValue.value) {
    return;
  }
  TUIStore.update(StoreName.CUSTOM, "currentSearchInputValue", {
    value: searchValueModel.value,
    searchType: props.searchType,
  });
};

const endSearching = () => {
  searchingStatus.value = false;
  TUIStore.update(StoreName.CUSTOM, "currentSearchingStatus", {
    isSearching: false,
    searchType: props.searchType,
  });
  TUIStore.update(StoreName.CUSTOM, "currentSearchInputValue", {
    value: "",
    searchType: props.searchType,
  });
};

const onFocus = () => {
  TUIStore.update(StoreName.CUSTOM, "currentSearchingStatus", {
    isSearching: true,
    searchType: props.searchType,
  });
};

return { __sfc: true,props, searchValueModel, currentSearchInputValue, searchingStatus, search, endSearching, onFocus, Icon, searchIcon, closeIcon }
}

})